<template>
<div class="chapter">
<div class="inner_page">
<p class="center-textst">“Nothing can be compared to the new life that the discovery of another country provides for a thoughtful person. Although I am still the same I believe to have changed to the bones.”</p>
<p class="center-texts"><span class="bold">Johann Wolfgang van Goethe</span><br/><em class="italic">T<span class="smallcaps">HE</span> I<span class="smallcaps">TALIAN</span> J<span class="smallcaps">OURNEY</span>,</em> 1816</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?64182561